export default {
    install(Vue, options) {
        Vue.component(Tabs.name, Tabs);
        Vue.component(Tab.name, Tab);
    }
};

const Tabs = {
    name: 'tabs',
    template: `
            <div>
                <div class="k-tabs">
                    <ul class="k-tabs__list">
                        <li v-for="tab in tabs" class="k-tabs__item" :class="[{'k-tabs__item--active': tab.isActive}]">
                            <a href="javascript:;" @click="selectTab(tab)" :title="tab.name" class="k-tabs__link k-tabs__list--nohover">{{ tab.name }}</a>
                        </li>
                    </ul>


                    <div v-if="rightLink !== undefined" class="k-tabs__actions">
                        <a :href="rightLink.url" class="k-tabs__actions-link">
                            <slot name="right-link"></slot>
                        </a>
                    </div>
                </div>
                <slot></slot>
            </div>

    `,

    props: {
        rightLink: {
            type: Object
        }
    },

    data() {
        return {
            tabs: []
        };
    },

    created() {
        this.tabs = this.$children;

    },
    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach(tab => {
                tab.isActive = (tab.name === selectedTab.name);
            });
        }
    }
};

const Tab = {
    name: 'tab',
    template: `

        <div v-show="isActive"><slot></slot></div>

    `,

    props: {
        name: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isActive: false
        };
    },

    computed: {
        href() {
            return '#' + this.name.toLowerCase().replace(/ /g, '-');
        }
    },

    mounted() {
        this.isActive = this.selected;
    }
};
